import '../-internals/meta/lib/meta.js';
import '../../shared-chunks/mandatory-setter-CXNsxygN.js';
import '@embroider/macros';
import '../debug/index.js';
import '../../@glimmer/destroyable/index.js';
import '../../@glimmer/validator/index.js';
import '../../@glimmer/manager/index.js';
export { x as addObserver, w as removeObserver } from '../../shared-chunks/cache-fCezwMOy.js';
import '../../shared-chunks/env-CwR5CFCu.js';
